// Custom animated banner + motif per docs page. Pure SVG/CSS.
const G = "#00DC82";
const L = "#F3F4F6";
const D = "#1E222D";

function GridBg() {
  return (
    <g stroke={D} strokeWidth="1" opacity="0.6">
      {[...Array(6)].map((_, i) => (
        <line key={`h${i}`} x1="0" y1={i * 30} x2="360" y2={i * 30} />
      ))}
      {[...Array(13)].map((_, i) => (
        <line key={`v${i}`} x1={i * 30} y1="0" x2={i * 30} y2="150" />
      ))}
    </g>
  );
}

function MotifInterlock() {
  return (
    <g>
      <g className="scene-spin" style={{ transformOrigin: "300px 75px" }}>
        <rect x="272" y="47" width="56" height="56" transform="rotate(45 300 75)" fill="none" stroke={D} strokeWidth="2" strokeDasharray="6 8" />
      </g>
      <rect x="266" y="41" width="34" height="34" transform="rotate(45 283 58)" fill="none" stroke={L} strokeWidth="2" />
      <rect x="300" y="75" width="34" height="34" transform="rotate(45 317 92)" fill="none" stroke={G} strokeWidth="2" />
    </g>
  );
}

function MotifLock() {
  return (
    <g>
      <g className="scene-lock-shackle">
        <path d="M283 70 V58 a17 17 0 0 1 34 0 V70" fill="none" stroke={L} strokeWidth="3" />
      </g>
      <rect x="277" y="70" width="46" height="36" rx="2" fill="none" stroke={G} strokeWidth="3" />
      <circle cx="300" cy="86" r="4" fill={G} />
    </g>
  );
}

function MotifBars() {
  const bars = [{ x: 258, h: 30 }, { x: 278, h: 52 }, { x: 298, h: 38 }, { x: 318, h: 64 }];
  return (
    <g>
      <line x1="250" y1="112" x2="340" y2="112" stroke={D} strokeWidth="1.5" />
      {bars.map((b, i) => (
        <rect key={i} className="scene-vest-bar" style={{ animationDelay: `${i * 0.2}s` }} x={b.x} y={112 - b.h} width="12" height={b.h} fill={G} opacity="0.9" />
      ))}
    </g>
  );
}

function MotifDistribute() {
  const paths = ["M250,75 L330,40", "M250,75 L330,75", "M250,75 L330,110"];
  return (
    <g>
      {paths.map((p, i) => <path key={i} d={p} stroke={D} strokeWidth="1.5" fill="none" />)}
      <circle cx="250" cy="75" r="7" fill="none" stroke={L} strokeWidth="2.5" />
      {[40, 75, 110].map((cy, i) => <circle key={i} cx="330" cy={cy} r="4.5" fill="none" stroke={G} strokeWidth="2" />)}
      {paths.map((p, i) => (
        <circle key={`d${i}`} className="scene-flow-dot" style={{ offsetPath: `path('${p}')`, animationDelay: `${i * 0.3}s` }} r="3.5" fill={G} />
      ))}
    </g>
  );
}

function MotifWaves() {
  return (
    <g fill="none" strokeWidth="2">
      <path className="scene-draw" d="M250 60 q20 -18 40 0 t40 0 t40 0" stroke={G} />
      <path className="scene-draw" style={{ animationDelay: "0.4s" }} d="M250 80 q20 -18 40 0 t40 0 t40 0" stroke={L} opacity="0.6" />
      <path className="scene-draw" style={{ animationDelay: "0.8s" }} d="M250 100 q20 -18 40 0 t40 0 t40 0" stroke={D} />
    </g>
  );
}

function MotifApi() {
  return (
    <g>
      <g className="scene-spin" style={{ transformOrigin: "300px 75px" }}>
        <circle cx="300" cy="75" r="34" fill="none" stroke={D} strokeWidth="2" strokeDasharray="4 9" />
      </g>
      <g className="scene-ring" style={{ transformOrigin: "300px 75px" }}>
        <circle cx="300" cy="75" r="6" fill={G} />
      </g>
      {[[300, 41], [334, 75], [300, 109], [266, 75]].map(([cx, cy], i) => (
        <circle key={i} cx={cx} cy={cy} r="3" fill={L} />
      ))}
    </g>
  );
}

function MotifShield() {
  return (
    <g>
      <path d="M300 42 l28 10 v20 c0 22 -14 34 -28 41 c-14 -7 -28 -19 -28 -41 v-20 z" fill="none" stroke={G} strokeWidth="2.5" />
      <path className="scene-draw" d="M288 78 l9 9 l17 -19" fill="none" stroke={L} strokeWidth="2.5" />
    </g>
  );
}

function MotifRobinhood() {
  return (
    <g>
      <g className="scene-ring" style={{ transformOrigin: "300px 75px" }}>
        <circle cx="300" cy="75" r="30" fill="none" stroke={D} strokeWidth="2" />
      </g>
      <path transform="translate(288 60) scale(1)" d="M2.84 24h.53c.096 0 .192-.048.224-.128C7.591 13.696 11.94 8.656 14.67 5.638c.112-.128.064-.225-.096-.225h-4.88a.55.55 0 0 0-.45.225L5.746 9.972c-.514.642-.642 1.236-.642 2.086v4.43c-1.14 3.194-1.862 5.361-2.392 7.32-.032.125.016.192.129.192M20.447.646c-.754-.802-4.157-.834-5.73-.224a3 3 0 0 0-.786.465 41 41 0 0 0-3.323 3.178c-.112.113-.064.225.097.225h5.409c.497 0 .786.289.786.786v6.1c0 .16.128.208.225.064l3.258-4.254c.53-.69.69-.898.835-1.861.192-1.413.08-3.58-.77-4.479m-6.982 16.18 2.231-3.676a.7.7 0 0 0 .064-.29V6.73c0-.16-.112-.225-.224-.097-3.355 3.74-5.971 7.672-8.395 12.407-.06.12.016.225.16.177l5.009-1.54c.565-.174.882-.402 1.155-.852" fill={G} />
    </g>
  );
}

function MotifRocket() {
  return (
    <g>
      <path d="M300 44 c14 8 20 24 20 40 l-10 8 h-20 l-10 -8 c0 -16 6 -32 20 -40z" fill="none" stroke={G} strokeWidth="2.5" />
      <circle cx="300" cy="72" r="6" fill="none" stroke={L} strokeWidth="2" />
      <g className="scene-ring" style={{ transformOrigin: "300px 104px" }}>
        <path d="M294 100 l6 14 l6 -14z" fill={G} />
      </g>
    </g>
  );
}

const MOTIFS = {
  interlock: MotifInterlock,
  lock: MotifLock,
  bars: MotifBars,
  distribute: MotifDistribute,
  waves: MotifWaves,
  api: MotifApi,
  shield: MotifShield,
  robinhood: MotifRobinhood,
  rocket: MotifRocket,
};

export function DocBanner({ eyebrow, title, motif = "interlock" }) {
  const Motif = MOTIFS[motif] || MotifInterlock;
  return (
    <div className="relative mb-8 overflow-hidden border border-welock-border bg-welock-surface">
      <svg viewBox="0 0 360 150" className="absolute right-0 top-0 h-full w-2/3" preserveAspectRatio="xMaxYMid slice">
        <GridBg />
        <Motif />
      </svg>
      <div className="relative max-w-lg p-8 md:p-10">
        <span className="eyebrow">{eyebrow}</span>
        <h1 className="mt-4 font-heading text-3xl font-normal tracking-tight text-welock-textPrimary md:text-4xl">
          {title}
        </h1>
      </div>
    </div>
  );
}
